import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'ms-split-header',
    templateUrl: './split-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet],
})
export class SplitHeaderComponent {
    @HostBinding('class.scroll-container') @Input() enableScroll: boolean;
    @ViewChild('scrollWrapper', { read: ElementRef, static: false }) scrollWrapper: ElementRef;
    constructor(private renderer: Renderer2) {}

    scrollToTop() {
        if (this.scrollWrapper?.nativeElement) {
            this.renderer.setProperty(this.scrollWrapper.nativeElement, 'scrollTop', 0);
        }
    }
}
